import { render, staticRenderFns } from "./music_videolist.vue?vue&type=template&id=4c920eb8&scoped=true&"
import script from "./music_videolist.vue?vue&type=script&lang=js&"
export * from "./music_videolist.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c920eb8",
  null
  
)

export default component.exports